import * as __d3ett from "./D3ETemplateTypes";
import GlobalFunctions from "../utils/GlobalFunctions";
import ResultStatus from "../classes/ResultStatus";
import AdminOrdersRequest from "../models/AdminOrdersRequest";
import Categories from "../classes/Categories";
import Admin from "../models/Admin";
import Customer from "../models/Customer";
import PortfolioProject from "../models/PortfolioProject";
import TaxRate from "../models/TaxRate";
import GradientType from "../classes/GradientType";
import LoginResult from "../classes/LoginResult";
import Customers from "../classes/Customers";
import ConnectionStatus from "../classes/ConnectionStatus";
import AdminSignUpRequest from "../models/AdminSignUpRequest";
import Provider from "../models/Provider";
import Taxes from "../classes/Taxes";
import OrderStatus from "../classes/OrderStatus";
import ServiceCallType from "../classes/ServiceCallType";
import ChartTheme from "../classes/ChartTheme";
import Businesses from "../classes/Businesses";
import ServiceCategory from "../models/ServiceCategory";
import BusinessStatus from "../classes/BusinessStatus";
import TaxesRequest from "../models/TaxesRequest";
import BusinessesRequest from "../models/BusinessesRequest";
import AdminOrders from "../classes/AdminOrders";
import Order from "../models/Order";
import IconType from "../classes/IconType";
import BusinessAddress from "../models/BusinessAddress";
import Business from "../models/Business";

export const ADDRESS: number = 0;

export const ADMIN: number = 1;

export const ADMINORDERS: number = 2;

export const ADMINORDERSREQUEST: number = 3;

export const ADMINSIGNUPREQUEST: number = 4;

export const BASEUSER: number = 5;

export const BLOB: number = 6;

export const BOOLEAN: number = 7;

export const BUSINESS: number = 8;

export const BUSINESSADDRESS: number = 9;

export const BUSINESSSTATUS: number = 10;

export const BUSINESSES: number = 11;

export const BUSINESSESREQUEST: number = 12;

export const CATEGORIES: number = 13;

export const CHARTTHEME: number = 14;

export const CONNECTIONSTATUS: number = 15;

export const CUSTOMER: number = 16;

export const CUSTOMERS: number = 17;

export const DFILE: number = 18;

export const DATE: number = 19;

export const DATETIME: number = 20;

export const DOUBLE: number = 21;

export const DURATION: number = 22;

export const GEOLOCATION: number = 23;

export const GRADIENTTYPE: number = 24;

export const ICONTYPE: number = 25;

export const INTEGER: number = 26;

export const LOGINRESULT: number = 27;

export const ORDER: number = 28;

export const ORDERSTATUS: number = 29;

export const PORTFOLIOPROJECT: number = 30;

export const PROVIDER: number = 31;

export const RESULTSTATUS: number = 32;

export const SERVICECALLTYPE: number = 33;

export const SERVICECATEGORY: number = 34;

export const STRING: number = 35;

export const TAXRATE: number = 36;

export const TAXES: number = 37;

export const TAXESREQUEST: number = 38;

export const TIME: number = 39;

export const TYPE: number = 40;

export const VOID: number = 41;

export class D3ETemplate {
  public static HASH: string = "1fb86a1e675b6602fba0a17b38b7c164";
  private static _usages: Array<__d3ett.D3EUsage> = [
    new __d3ett.D3EUsage(
      "Query_getAdminOrders_AdminBusinessDetailsPage_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(ADMINORDERS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(ORDER, [
              new __d3ett.D3EFieldUsage(0, [
                new __d3ett.D3ETypeUsage(BUSINESS, [
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(4, [
                    new __d3ett.D3ETypeUsage(DFILE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(5, []),
                  new __d3ett.D3EFieldUsage(7, [
                    new __d3ett.D3ETypeUsage(PROVIDER, [
                      new __d3ett.D3EFieldUsage(0, [
                        new __d3ett.D3ETypeUsage(BUSINESS, []),
                      ]),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, [
                        new __d3ett.D3ETypeUsage(DFILE, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(3, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(4, []),
                      new __d3ett.D3EFieldUsage(5, []),
                      new __d3ett.D3EFieldUsage(6, [
                        new __d3ett.D3ETypeUsage(DFILE, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(3, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                    ]),
                    new __d3ett.D3ETypeUsage(BASEUSER, []),
                  ]),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(CUSTOMER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "2207b596b72b3835ebd02744be0a871d"
    ),
    new __d3ett.D3EUsage(
      "Query_getAdminOrders_AdminDashboardPage2_properties_query_computation",
      [
        new __d3ett.D3ETypeUsage(ADMINORDERS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(ORDER, [
              new __d3ett.D3EFieldUsage(0, [
                new __d3ett.D3ETypeUsage(BUSINESS, []),
              ]),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(CUSTOMER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "25537d92c358ba58bfffa7de8d41e9cc"
    ),
    new __d3ett.D3EUsage(
      "Query_getBusinesses_AdminBusinessManagementPage_properties_businessessList_computation",
      [
        new __d3ett.D3ETypeUsage(BUSINESSES, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(BUSINESS, [
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(5, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "5ac15c7cba351e257af8c5524cd281e7"
    ),
    new __d3ett.D3EUsage(
      "Query_getCategories_AdminCategoryManagementPage_properties_categoriesList_computation",
      [
        new __d3ett.D3ETypeUsage(CATEGORIES, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, [
            new __d3ett.D3ETypeUsage(SERVICECATEGORY, [
              new __d3ett.D3EFieldUsage(0, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(2, []),
        ]),
      ],
      "72e67ca6f726dc5f652abd75e2b77c6e"
    ),
    new __d3ett.D3EUsage(
      "Query_getCustomers_AdminDashboardPage2_properties_customersList_computation",
      [
        new __d3ett.D3ETypeUsage(CUSTOMERS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(CUSTOMER, []),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "952c8fbed273b063318f49ab397216ba"
    ),
    new __d3ett.D3EUsage(
      "Query_getTaxes_AdminConfigurationPage_properties_taxList_computation",
      [
        new __d3ett.D3ETypeUsage(TAXES, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, [
            new __d3ett.D3ETypeUsage(TAXRATE, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(2, []),
        ]),
      ],
      "0fe59502883ca322a400be8169f3c9c3"
    ),
    new __d3ett.D3EUsage(
      "Query_loginAdminUserWithEmailAndPassword_AdminLoginPage_eventHandlers_doAuthenticateUser_block",
      [
        new __d3ett.D3ETypeUsage(LOGINRESULT, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, []),
          new __d3ett.D3EFieldUsage(3, [
            new __d3ett.D3ETypeUsage(ADMIN, [
              new __d3ett.D3EFieldUsage(0, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
            ]),
            new __d3ett.D3ETypeUsage(CUSTOMER, []),
            new __d3ett.D3ETypeUsage(PROVIDER, [
              new __d3ett.D3EFieldUsage(0, [
                new __d3ett.D3ETypeUsage(BUSINESS, []),
              ]),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
              new __d3ett.D3EFieldUsage(6, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
            ]),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
        ]),
      ],
      "4c8a3119ffdf7fad240e44ce3e74489b"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onAdminOrdersChange_AdminBusinessDetailsPage_query_synchronise",
      [
        new __d3ett.D3ETypeUsage(ADMINORDERS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(ORDER, [
              new __d3ett.D3EFieldUsage(0, [
                new __d3ett.D3ETypeUsage(BUSINESS, [
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(4, [
                    new __d3ett.D3ETypeUsage(DFILE, [
                      new __d3ett.D3EFieldUsage(0, []),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, []),
                    ]),
                  ]),
                  new __d3ett.D3EFieldUsage(5, []),
                  new __d3ett.D3EFieldUsage(7, [
                    new __d3ett.D3ETypeUsage(PROVIDER, [
                      new __d3ett.D3EFieldUsage(0, [
                        new __d3ett.D3ETypeUsage(BUSINESS, []),
                      ]),
                      new __d3ett.D3EFieldUsage(1, []),
                      new __d3ett.D3EFieldUsage(2, [
                        new __d3ett.D3ETypeUsage(DFILE, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(3, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                      new __d3ett.D3EFieldUsage(3, []),
                      new __d3ett.D3EFieldUsage(4, []),
                      new __d3ett.D3EFieldUsage(5, []),
                      new __d3ett.D3EFieldUsage(6, [
                        new __d3ett.D3ETypeUsage(DFILE, [
                          new __d3ett.D3EFieldUsage(0, []),
                          new __d3ett.D3EFieldUsage(3, []),
                          new __d3ett.D3EFieldUsage(1, []),
                          new __d3ett.D3EFieldUsage(2, []),
                        ]),
                      ]),
                    ]),
                    new __d3ett.D3ETypeUsage(BASEUSER, []),
                  ]),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(CUSTOMER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "2207b596b72b3835ebd02744be0a871d"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onAdminOrdersChange_AdminDashboardPage2_query_synchronise",
      [
        new __d3ett.D3ETypeUsage(ADMINORDERS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(ORDER, [
              new __d3ett.D3EFieldUsage(0, [
                new __d3ett.D3ETypeUsage(BUSINESS, []),
              ]),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, [
                new __d3ett.D3ETypeUsage(CUSTOMER, []),
                new __d3ett.D3ETypeUsage(BASEUSER, []),
              ]),
              new __d3ett.D3EFieldUsage(4, []),
              new __d3ett.D3EFieldUsage(5, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "25537d92c358ba58bfffa7de8d41e9cc"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onBusinessesChange_AdminBusinessManagementPage_businessessList_synchronise",
      [
        new __d3ett.D3ETypeUsage(BUSINESSES, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(BUSINESS, [
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(5, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "5ac15c7cba351e257af8c5524cd281e7"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onCategoriesChange_AdminCategoryManagementPage_categoriesList_synchronise",
      [
        new __d3ett.D3ETypeUsage(CATEGORIES, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, [
            new __d3ett.D3ETypeUsage(SERVICECATEGORY, [
              new __d3ett.D3EFieldUsage(0, [
                new __d3ett.D3ETypeUsage(DFILE, [
                  new __d3ett.D3EFieldUsage(0, []),
                  new __d3ett.D3EFieldUsage(3, []),
                  new __d3ett.D3EFieldUsage(1, []),
                  new __d3ett.D3EFieldUsage(2, []),
                ]),
              ]),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
              new __d3ett.D3EFieldUsage(3, []),
              new __d3ett.D3EFieldUsage(4, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(2, []),
        ]),
      ],
      "72e67ca6f726dc5f652abd75e2b77c6e"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onCustomersChange_AdminDashboardPage2_customersList_synchronise",
      [
        new __d3ett.D3ETypeUsage(CUSTOMERS, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, []),
          new __d3ett.D3EFieldUsage(2, [
            new __d3ett.D3ETypeUsage(CUSTOMER, []),
            new __d3ett.D3ETypeUsage(BASEUSER, []),
          ]),
          new __d3ett.D3EFieldUsage(3, []),
        ]),
      ],
      "952c8fbed273b063318f49ab397216ba"
    ),
    new __d3ett.D3EUsage(
      "Subscription_onTaxesChange_AdminConfigurationPage_taxList_synchronise",
      [
        new __d3ett.D3ETypeUsage(TAXES, [
          new __d3ett.D3EFieldUsage(0, []),
          new __d3ett.D3EFieldUsage(1, [
            new __d3ett.D3ETypeUsage(TAXRATE, [
              new __d3ett.D3EFieldUsage(0, []),
              new __d3ett.D3EFieldUsage(1, []),
              new __d3ett.D3EFieldUsage(2, []),
            ]),
          ]),
          new __d3ett.D3EFieldUsage(2, []),
        ]),
      ],
      "0fe59502883ca322a400be8169f3c9c3"
    ),
  ];
  private static _types: Array<__d3ett.D3ETemplateType> = [
    new __d3ett.D3ETemplateType(
      "Address",
      "add3b7eec4b5cfa54c1c91222669ed81",
      [
        new __d3ett.D3ETemplateField(
          "fullAddress",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      { "abstract": true, "refType": __d3ett.D3ERefType.Model }
    ),
    new __d3ett.D3ETemplateType(
      "Admin",
      "325d274567c2da63da5b6db83db6e6ce",
      [
        new __d3ett.D3ETemplateField(
          "avatar",
          DFILE,
          __d3ett.D3EFieldType.DFile,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "email",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "mobile",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "parent": 5,
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new Admin(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "AdminOrders",
      "e20ce2055e4b3f2f9968f2b8a3355b5a",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField("items", ORDER, __d3ett.D3EFieldType.Ref, {
          "collection": true,
        }),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new AdminOrders(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "AdminOrdersRequest",
      "edd4c20174e749db96fd36d88e64b303",
      [
        new __d3ett.D3ETemplateField(
          "applyStatus",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "business",
          BUSINESS,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "fromDate",
          DATE,
          __d3ett.D3EFieldType.Date,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "status",
          ORDERSTATUS,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "toDate",
          DATE,
          __d3ett.D3EFieldType.Date,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new AdminOrdersRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "AdminSignUpRequest",
      "62218b7c173a9b9870b4bd1d054f9746",
      [
        new __d3ett.D3ETemplateField(
          "allowUserManagement",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "email",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "password",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new AdminSignUpRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "BaseUser",
      "5116c054754a25edc5a13eddbd47e85a",
      [],
      { "abstract": true, "refType": __d3ett.D3ERefType.Model }
    ),
    new __d3ett.D3ETemplateType(
      "Blob",
      "e8016c85ada38bdc5fac616ec1318047",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Boolean",
      "27226c864bac7454a8504f8edb15d95b",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Business",
      "fc778a7c9b7e1991704286497bafc8ad",
      [
        new __d3ett.D3ETemplateField(
          "address",
          BUSINESSADDRESS,
          __d3ett.D3EFieldType.Ref,
          { "inverse": true }
        ),
        new __d3ett.D3ETemplateField(
          "businessStatus",
          BUSINESSSTATUS,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "createdDate",
          DATETIME,
          __d3ett.D3EFieldType.DateTime,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "details",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "logo",
          DFILE,
          __d3ett.D3EFieldType.DFile,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "portfolioProjects",
          PORTFOLIOPROJECT,
          __d3ett.D3EFieldType.Ref,
          { "collection": true, "inverse": true }
        ),
        new __d3ett.D3ETemplateField(
          "providers",
          PROVIDER,
          __d3ett.D3EFieldType.Ref,
          { "collection": true, "inverse": true }
        ),
      ],
      { "refType": __d3ett.D3ERefType.Model, "creator": () => new Business() }
    ),
    new __d3ett.D3ETemplateType(
      "BusinessAddress",
      "f08ca7ad8a2f79cd1f3c3ad78e754f33",
      [],
      {
        "parent": 0,
        "parentFields": 1,
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new BusinessAddress(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "BusinessStatus",
      "68924cc53a52b562e1aad732242b9ca1",
      [
        new __d3ett.D3ETemplateField("Pending", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Active", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Inactive", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Suspended", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "Businesses",
      "229f481ff7de6a1c58d646a37e25c5cb",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          BUSINESS,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new Businesses(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "BusinessesRequest",
      "ab066363747be7522a22f87595423f6e",
      [
        new __d3ett.D3ETemplateField(
          "ascending",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "offset",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "orderBy",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "pageSize",
          INTEGER,
          __d3ett.D3EFieldType.Integer,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new BusinessesRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "Categories",
      "cb2394950e5d718ee0bc176bbceaf883",
      [
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          SERVICECATEGORY,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new Categories(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "ChartTheme",
      "e342912451bba89ca33768533f538057",
      [
        new __d3ett.D3ETemplateField("Fusion", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Gammel", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Candy", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Ocean", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Zune", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Carbon", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Umber", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "ConnectionStatus",
      "0d5c2bfbc6b6e414981c0c67321165d5",
      [
        new __d3ett.D3ETemplateField(
          "Connecting",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField("Connected", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField(
          "ConnectionBusy",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "ConnectionNormal",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "ConnectionFailed",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "RestoreFailed",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "AuthFailed",
          0,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "Customer",
      "7024523315bc3201272b79b60316e0bd",
      [],
      {
        "parent": 5,
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new Customer(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "Customers",
      "8a78190ff2845d4927f9781b5a77e386",
      [
        new __d3ett.D3ETemplateField(
          "count",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          CUSTOMER,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      { "refType": __d3ett.D3ERefType.Struct, "creator": () => new Customers() }
    ),
    new __d3ett.D3ETemplateType(
      "DFile",
      "71a781845a8ebe8adf67352a573af199",
      [
        new __d3ett.D3ETemplateField("id", STRING, __d3ett.D3EFieldType.String),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String
        ),
        new __d3ett.D3ETemplateField(
          "size",
          INTEGER,
          __d3ett.D3EFieldType.Integer
        ),
        new __d3ett.D3ETemplateField(
          "mimeType",
          STRING,
          __d3ett.D3EFieldType.String
        ),
      ],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Date",
      "44749712dbec183e983dcd78a7736c41",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "DateTime",
      "8cf10d2341ed01492506085688270c1e",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Double",
      "d909d38d705ce75386dd86e611a82f5b",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Duration",
      "e02d2ae03de9d493df2b6b2d2813d302",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Geolocation",
      "323d4eb70b252acb4a04eaf9e0882597",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "GradientType",
      "dfc80f7e140e2dac94987925914062a8",
      [
        new __d3ett.D3ETemplateField("Color", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField(
          "LinearGradient",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "SweepGradient",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField(
          "RadialGradient",
          0,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "IconType",
      "4529ef025543fdd73b83290b6c7b541f",
      [
        new __d3ett.D3ETemplateField("SVG", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Font", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "Integer",
      "a0faef0851b4294c06f2b94bb1cb2044",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "LoginResult",
      "43b15c92fa28924318ec2dd9b20d65d3",
      [
        new __d3ett.D3ETemplateField(
          "failureMessage",
          STRING,
          __d3ett.D3EFieldType.String
        ),
        new __d3ett.D3ETemplateField(
          "success",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean
        ),
        new __d3ett.D3ETemplateField(
          "token",
          STRING,
          __d3ett.D3EFieldType.String
        ),
        new __d3ett.D3ETemplateField(
          "userObject",
          BASEUSER,
          __d3ett.D3EFieldType.Ref
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Struct,
        "creator": () => new LoginResult(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "Order",
      "58f3042d56ddd9420b905778cf965068",
      [
        new __d3ett.D3ETemplateField(
          "business",
          BUSINESS,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "callType",
          SERVICECALLTYPE,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "createdDate",
          DATETIME,
          __d3ett.D3EFieldType.DateTime,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "customer",
          CUSTOMER,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "orderDate",
          DATE,
          __d3ett.D3EFieldType.Date,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "status",
          ORDERSTATUS,
          __d3ett.D3EFieldType.Enum,
          {}
        ),
      ],
      { "refType": __d3ett.D3ERefType.Model, "creator": () => new Order() }
    ),
    new __d3ett.D3ETemplateType(
      "OrderStatus",
      "cbcb90a6e28d14c38da368030f9af3ec",
      [
        new __d3ett.D3ETemplateField("Draft", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Placed", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField(
          "Processing",
          0,
          __d3ett.D3EFieldType.Enum
        ),
        new __d3ett.D3ETemplateField("Completed", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Cancelled", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "PortfolioProject",
      "02d907127b14257e0312113f05ae5435",
      [
        new __d3ett.D3ETemplateField(
          "attachments",
          DFILE,
          __d3ett.D3EFieldType.DFile,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "business",
          BUSINESS,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "details",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "title",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new PortfolioProject(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "Provider",
      "3f116a63465bb5c94cb34cb182576c26",
      [
        new __d3ett.D3ETemplateField(
          "business",
          BUSINESS,
          __d3ett.D3EFieldType.Ref,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "email",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "iDProof",
          DFILE,
          __d3ett.D3EFieldType.DFile,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "isManager",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "phone",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "profile",
          DFILE,
          __d3ett.D3EFieldType.DFile,
          {}
        ),
      ],
      {
        "parent": 5,
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new Provider(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "ResultStatus",
      "b3e4a20b998b614cb3f7bd669946ae7f",
      [
        new __d3ett.D3ETemplateField("Success", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("Errors", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "ServiceCallType",
      "53a739907491db9abf324dbfd027f3d5",
      [
        new __d3ett.D3ETemplateField("InCall", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("OutCall", 0, __d3ett.D3EFieldType.Enum),
        new __d3ett.D3ETemplateField("TeleCall", 0, __d3ett.D3EFieldType.Enum),
      ],
      { "refType": __d3ett.D3ERefType.Enum }
    ),
    new __d3ett.D3ETemplateType(
      "ServiceCategory",
      "567460281b7399b2eb33288819f3ce40",
      [
        new __d3ett.D3ETemplateField(
          "image",
          DFILE,
          __d3ett.D3EFieldType.DFile,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "inCall",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "name",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "outCall",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "teleCall",
          BOOLEAN,
          __d3ett.D3EFieldType.Boolean,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new ServiceCategory(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "String",
      "27118326006d3829667a400ad23d5d98",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "TaxRate",
      "274d069b9c540ee2fe9790d6bd3085ba",
      [
        new __d3ett.D3ETemplateField(
          "country",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "jurisdiction",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
        new __d3ett.D3ETemplateField(
          "rate",
          DOUBLE,
          __d3ett.D3EFieldType.Double,
          {}
        ),
      ],
      { "refType": __d3ett.D3ERefType.Model, "creator": () => new TaxRate() }
    ),
    new __d3ett.D3ETemplateType(
      "Taxes",
      "978149983afdc2eda6081b7e5448d1f8",
      [
        new __d3ett.D3ETemplateField(
          "errors",
          STRING,
          __d3ett.D3EFieldType.String,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "items",
          TAXRATE,
          __d3ett.D3EFieldType.Ref,
          { "collection": true }
        ),
        new __d3ett.D3ETemplateField(
          "status",
          RESULTSTATUS,
          __d3ett.D3EFieldType.Enum
        ),
      ],
      { "refType": __d3ett.D3ERefType.Struct, "creator": () => new Taxes() }
    ),
    new __d3ett.D3ETemplateType(
      "TaxesRequest",
      "88d40e333cdf95569f54f35831c09d32",
      [
        new __d3ett.D3ETemplateField(
          "country",
          STRING,
          __d3ett.D3EFieldType.String,
          {}
        ),
      ],
      {
        "refType": __d3ett.D3ERefType.Model,
        "creator": () => new TaxesRequest(),
      }
    ),
    new __d3ett.D3ETemplateType(
      "Time",
      "a76d4ef5f3f6a672bbfab2865563e530",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "Type",
      "a1fa27779242b4902f7ae3bdd5c6d508",
      [],
      {}
    ),
    new __d3ett.D3ETemplateType(
      "void",
      "cab8111fd0b710a336c898e539090e34",
      [],
      {}
    ),
  ];
  private static readonly _typeMap: Map<string, number> = Map.fromIterables(
    D3ETemplate._types.map((x) => x.name),
    Array.generate(D3ETemplate._types.length, (index) => index)
  );
  public static allFields(type: number): Array<number> {
    return Array.generate(
      D3ETemplate._types[type].fields.length,
      (index) => index
    );
  }
  public static get types(): Array<__d3ett.D3ETemplateType> {
    return D3ETemplate._types;
  }
  public static get usages(): Array<__d3ett.D3EUsage> {
    return D3ETemplate._usages;
  }
  public static typeString(val: number): string {
    return D3ETemplate._types[val].name;
  }
  public static typeInt(val: string): number {
    return D3ETemplate._typeMap.get(val);
  }
  public static _getField(type: number, val: number): __d3ett.D3ETemplateField {
    let _type: __d3ett.D3ETemplateType = D3ETemplate._types[type];

    /*
_type will have fields with index starting from _type.parentFields.
Anything less needs to be looked up in _type.parent.
*/

    if (val < _type.parentFields) {
      return D3ETemplate._getField(_type.parent, val);
    }

    /*
The field cannot be in _type's child, so subtract _type.parentField from val, and use that as index.
*/

    let adjustedIndex: number = val - _type.parentFields;

    return _type.fields[adjustedIndex];
  }
  public static fieldString(type: number, val: number): string {
    return D3ETemplate._getField(type, val).name;
  }
  public static fieldType(type: number, val: number): number {
    return D3ETemplate._getField(type, val).type;
  }
  public static isChild(type: number, val: number): boolean {
    return D3ETemplate._getField(type, val).child;
  }
  public static fieldInt(type: number, val: string): number {
    let _type: __d3ett.D3ETemplateType = D3ETemplate._types[type];

    if (_type.fieldMap.containsKey(val)) {
      return _type.fieldMap[val];
    }

    if (_type.parent != null) {
      return D3ETemplate.fieldInt(_type.parent, val);
    }

    return null;
  }
  public static isEmbedded(type: number): boolean {
    return D3ETemplate._types[type].embedded;
  }
  public static isAbstract(type: number): boolean {
    return D3ETemplate._types[type].abstract;
  }
  public static hasParent(type: number): boolean {
    return D3ETemplate._types[type].parent != null;
  }
  public static parent(type: number): number {
    return D3ETemplate._types[type].parent;
  }
  public static getEnumField<T>(type: number, field: number): T {
    switch (type) {
      case BUSINESSSTATUS: {
        return BusinessStatus.values[field] as unknown as T;
      }

      case CHARTTHEME: {
        return ChartTheme.values[field] as unknown as T;
      }

      case CONNECTIONSTATUS: {
        return ConnectionStatus.values[field] as unknown as T;
      }

      case GRADIENTTYPE: {
        return GradientType.values[field] as unknown as T;
      }

      case ICONTYPE: {
        return IconType.values[field] as unknown as T;
      }

      case ORDERSTATUS: {
        return OrderStatus.values[field] as unknown as T;
      }

      case RESULTSTATUS: {
        return ResultStatus.values[field] as unknown as T;
      }

      case SERVICECALLTYPE: {
        return ServiceCallType.values[field] as unknown as T;
      }
    }
  }
}

export class UsageConstants {
  public static readonly QUERY_GETADMINORDERS_ADMINBUSINESSDETAILSPAGE_PROPERTIES_QUERY_COMPUTATION: number = 0;
  public static readonly QUERY_GETADMINORDERS_ADMINDASHBOARDPAGE2_PROPERTIES_QUERY_COMPUTATION: number = 1;
  public static readonly QUERY_GETBUSINESSES_ADMINBUSINESSMANAGEMENTPAGE_PROPERTIES_BUSINESSESSLIST_COMPUTATION: number = 2;
  public static readonly QUERY_GETCATEGORIES_ADMINCATEGORYMANAGEMENTPAGE_PROPERTIES_CATEGORIESLIST_COMPUTATION: number = 3;
  public static readonly QUERY_GETCUSTOMERS_ADMINDASHBOARDPAGE2_PROPERTIES_CUSTOMERSLIST_COMPUTATION: number = 4;
  public static readonly QUERY_GETTAXES_ADMINCONFIGURATIONPAGE_PROPERTIES_TAXLIST_COMPUTATION: number = 5;
  public static readonly QUERY_LOGINADMINUSERWITHEMAILANDPASSWORD_ADMINLOGINPAGE_EVENTHANDLERS_DOAUTHENTICATEUSER_BLOCK: number = 6;
  public static readonly SUBSCRIPTION_ONADMINORDERSCHANGE_ADMINBUSINESSDETAILSPAGE_QUERY_SYNCHRONISE: number = 7;
  public static readonly SUBSCRIPTION_ONADMINORDERSCHANGE_ADMINDASHBOARDPAGE2_QUERY_SYNCHRONISE: number = 8;
  public static readonly SUBSCRIPTION_ONBUSINESSESCHANGE_ADMINBUSINESSMANAGEMENTPAGE_BUSINESSESSLIST_SYNCHRONISE: number = 9;
  public static readonly SUBSCRIPTION_ONCATEGORIESCHANGE_ADMINCATEGORYMANAGEMENTPAGE_CATEGORIESLIST_SYNCHRONISE: number = 10;
  public static readonly SUBSCRIPTION_ONCUSTOMERSCHANGE_ADMINDASHBOARDPAGE2_CUSTOMERSLIST_SYNCHRONISE: number = 11;
  public static readonly SUBSCRIPTION_ONTAXESCHANGE_ADMINCONFIGURATIONPAGE_TAXLIST_SYNCHRONISE: number = 12;
}

export class ChannelConstants {
  public static readonly TOTAL_CHANNEL_COUNT: number = 0;
  public static readonly channels: Array<__d3ett.D3ETemplateClass> = [];
}

export class RPCConstants {
  public static readonly UniqueChecker: number = 0;
  public static readonly UniqueCheckerCheckEmailUniqueInAdmin: number = 0;
  public static readonly UniqueCheckerCheckEmailUniqueInAdminSignUpRequest: number = 1;
  public static readonly UniqueCheckerCheckProviderEmailUniqueInBusiness: number = 2;
  public static readonly UNIQUECHECKER_PROCEDURE_COUNT: number = 3;
  public static readonly FileService: number = 1;
  public static readonly FILESERVICE_PROCEDURE_COUNT: number = 0;
  public static readonly ConfigurationUtils: number = 2;
  public static readonly ConfigurationUtilsGetAdminApproval: number = 0;
  public static readonly ConfigurationUtilsSetAdminApproval: number = 1;
  public static readonly CONFIGURATIONUTILS_PROCEDURE_COUNT: number = 2;
  public static readonly ProviderUtils: number = 3;
  public static readonly PROVIDERUTILS_PROCEDURE_COUNT: number = 0;
  public static readonly GoogleMapServiceRun: number = 4;
  public static readonly GOOGLEMAPSERVICERUN_PROCEDURE_COUNT: number = 0;
  public static readonly TOTAL_RPC_CLASS_COUNT: number = 5;
  public static readonly classes: Array<__d3ett.D3ETemplateClass> = [
    new __d3ett.D3ETemplateClass(
      "UniqueChecker",
      "b165e8e66226cb2afe0857c019d44874",
      [
        new __d3ett.D3ETemplateMethodWithReturn(
          "checkEmailUniqueInAdmin",
          [
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("Admin"), {}),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
          ],
          D3ETemplate.typeInt("Boolean"),
          {}
        ),
        new __d3ett.D3ETemplateMethodWithReturn(
          "checkEmailUniqueInAdminSignUpRequest",
          [
            new __d3ett.D3ETemplateParam(
              D3ETemplate.typeInt("AdminSignUpRequest"),
              {}
            ),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
          ],
          D3ETemplate.typeInt("Boolean"),
          {}
        ),
        new __d3ett.D3ETemplateMethodWithReturn(
          "checkProviderEmailUniqueInBusiness",
          [
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("Business"), {}),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("Provider"), {}),
            new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("String"), {}),
          ],
          D3ETemplate.typeInt("Boolean"),
          {}
        ),
      ]
    ),
    new __d3ett.D3ETemplateClass(
      "FileService",
      "e256e0e9ad423eb20c85f506f4580ce8",
      []
    ),
    new __d3ett.D3ETemplateClass(
      "ConfigurationUtils",
      "49eaba480ae047e7f025a4d7305be53e",
      [
        new __d3ett.D3ETemplateMethodWithReturn(
          "getAdminApproval",
          [],
          D3ETemplate.typeInt("Boolean"),
          {}
        ),
        new __d3ett.D3ETemplateMethodWithReturn(
          "setAdminApproval",
          [new __d3ett.D3ETemplateParam(D3ETemplate.typeInt("Boolean"), {})],
          D3ETemplate.typeInt("void"),
          {}
        ),
      ]
    ),
    new __d3ett.D3ETemplateClass(
      "ProviderUtils",
      "4436c25a1903f57d727ed8f90e80291f",
      []
    ),
    new __d3ett.D3ETemplateClass(
      "GoogleMapServiceRun",
      "078d05e0594d2ad3452ded208fca8e50",
      []
    ),
  ];
}
GlobalFunctions.typeInt = D3ETemplate.typeInt;

GlobalFunctions.types = D3ETemplate.types;
